export default __webpack_public_path__ + "static/media/trust-clg-03.2f314f3d.jpg";